import { observable, makeObservable } from 'mobx';
export class ProfileStore {
    constructor(services, data) {
        this.display = {};
        if (!data?.profile?.tag) {
            return;
        }
        this.tag = data.profile.tag;
        this.placement = data.profile.placement;
        this.display = data.profile.display;
        makeObservable(this, {
            tag: observable,
            placement: observable,
            display: observable,
        });
    }
}
